var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-product-display-controls" }, [
    _vm.showSizeControl
      ? _c(
          "div",
          {
            staticClass:
              "wf-product-display-control wf-product-display-control-filter"
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "wf-side-collapse-button wf-side-collapse-button-open btn shadow",
                attrs: {
                  type: "button",
                  "data-wf-collapse-target": "#filters-side-collapse"
                }
              },
              [
                _c("span", { staticClass: "pr-3" }, [
                  _vm._v(
                    _vm._s(_vm.$resourceString["product.search.display.filter"])
                  )
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass:
                    "png-icon png-icon-icons-glyph--k-sort-filter m-0"
                })
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "wf-product-display-control wf-product-display-control-tile-size show-on-desktop"
      },
      [
        _c(
          "select",
          {
            staticClass: "custom-select",
            attrs: { name: "product-display-tile-size" },
            on: { change: _vm.setTileSize }
          },
          [
            _c("option", { attrs: { disabled: "", value: "" } }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$resourceString["product.search.display.tile.size"]
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "option",
              {
                attrs: { value: "small" },
                domProps: { selected: _vm.tileSize == "small" }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$resourceString[
                        "product.search.display.tile.size.small"
                      ]
                    ) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "option",
              {
                attrs: { value: "large" },
                domProps: { selected: _vm.tileSize == "large" }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$resourceString[
                        "product.search.display.tile.size.large"
                      ]
                    ) +
                    "\n            "
                )
              ]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _vm.showSortControl
      ? _c(
          "div",
          {
            staticClass:
              "wf-product-display-control wf-product-display-control-sort-by"
          },
          [
            _c(
              "select",
              {
                staticClass: "custom-select",
                attrs: { name: "product-display-sort-by" },
                on: { change: _vm.setSortOrder }
              },
              [
                _c(
                  "option",
                  {
                    attrs: { value: "SellingStyleName desc" },
                    domProps: { selected: _vm.isAscendingOrder === "desc" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$resourceString[
                            "product.search.display.sort.by.za"
                          ]
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "option",
                  {
                    attrs: { value: "SellingStyleName asc" },
                    domProps: { selected: _vm.isAscendingOrder === "asc" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$resourceString[
                            "product.search.display.sort.by.alphabet"
                          ]
                        ) +
                        "\n            "
                    )
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }